import React from 'react';
import { Group, Rect } from 'react-konva';

const ProgressBar = ({ styles }) => {
  return (
    <Group>
      {/* Background */}
      <Rect
        width={styles.width}
        height={styles.height}
        fill={styles.backgroundColor}
        cornerRadius={styles.borderRadius}
        stroke={styles.borderColor}
        strokeWidth={styles.borderWidth}
      />
      {/* Fill */}
      <Rect
        width={styles.width * (styles.progress / 100)}
        height={styles.height}
        fill={styles.fillColor}
        cornerRadius={styles.borderRadius}
      />
    </Group>
  );
};

export default ProgressBar;
